
import { NotificationDetail, NotificationRaw } from '../types';

export function transformNotification(raw: NotificationRaw): NotificationDetail {
    return {
        id: raw.id,
        status: raw.status || null,
        dateCreated: raw.date_created || null,
        user: raw.user || null,
        type: raw.type || null,
        title: raw.title || null,
        relatedEntity: raw.related_entity || null,
        actionUrl: raw.action_url || null,
        isRead: raw.is_read || false,
        priority: raw.priority || null,
        readAt: raw.read_at || null,
        expiresAt: raw.expires_at || null,
    };
}

export function transformNotifications(rawNotifications: NotificationRaw[]): NotificationDetail[] {
    return rawNotifications.map(transformNotification);
}
